import type { ReminderResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import type { Reminder } from "web_myplann/Reminders/Types/ReminderTypes";
import { parseApiDate } from "web_myplann/Shared/Utils/apiDate";

export const mapReminderDto = (dto: ReminderResponseDTO): Reminder => ({
	id: String(dto.id),
	typeKey: dto.typeKey,
	name: dto.title,
	date: parseApiDate(dto.date),
	recurrence: dto.recurrence,
	status: dto.status,
	snoozedUntil: dto.snoozedUntil ? parseApiDate(dto.snoozedUntil) : null,
});
